import type { FaireProductEntity } from "../../entity_types/product";

export const p_vezk24xebv: FaireProductEntity = {
  token: "p_vezk24xebv",
  type: "product",
  name: "Zircon double Snake 18K Gold Plated S.Steel Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/82159ba3e7bc6e4e91266bb67a9a90af4cb3a38cc4a553b9e30d7054c9b9c7b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/194492c1cb57713c4ec1837aacc798ce3edd1e9295652a73e9ff99e96cc0bb6a.jpeg",
    "https://cdn.faire.com/fastly/4f2f9abdd6fc2dc1ef992ba3240fe4281450ac007faa9001255eca735c86841d.jpeg",
    "https://cdn.faire.com/fastly/40dfb4b3124c4bcc7f91e36704a0f8a28ac6d65e7ddd6e7457fc25036e95f540.jpeg",
  ],
  priceDollars: 9.1,
  description:
    "Type: Pendant necklace\nMaterial: Stainless steel ，Zircon，18K gold plated\nSize of pendant : 22mm*58mm\nLength of chain : 380mm+50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 22.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:27.962Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
